export default __webpack_public_path__ + "static/media/info.5475e536.svg";